import React, { Component } from 'react';
import { connect } from 'react-redux';
import MedicalInformationForm from './MedicalInformationForm';
import { fetchChildMedicalInformation, updateChildMedicalInformation } from './actions';
import { withTranslation } from 'react-i18next';
import { getFormValues, change, SubmissionError } from 'redux-form';
import Components from '../assessmentForms/Components';
import AssessmentForm from '../assessmentForms/Form';

class MedicalInformation extends Component {

	componentDidMount() {
		this.props.fetchChildMedicalInformation(Number(this.props.childId));
	}

	handleFormSubmit(values, requiredFields, validationFunc) {
		const { child, medicalInformation, t } = this.props;

		let errors = {};
		if (requiredFields) {
			requiredFields.forEach(field => {
				if (values[field] == null || values[field] === '') {	// null, undefined or empty are invalid, 0 is a valid value
					errors[field] = t('Validator_Required');
				}
			});
		}

		if (validationFunc) {
			errors = Object.assign(errors, validationFunc(values, t));
		}

		// throw redux-form error if fields are missing when submiting form
		if (Object.keys(errors).length > 0) {
			throw new SubmissionError(errors);
		}

		this.props.updateChildMedicalInformation(child.id, {
			childId: child.id,
			formId: medicalInformation.form.id,
			content: values
		});
	}

	render() {
		const { medicalInformation, currentFormValues, changeFormValue, isReadOnly, t } = this.props;
		const { component, requiredFields, validationFunc } = medicalInformation ?
			Components(medicalInformation, currentFormValues, changeFormValue) :
			{ component: null, requiredFields: [], validationFunc: null };

		return (
			<div>
				{medicalInformation && <AssessmentForm
					title={''}
					formComponent={component}
					initialValues={medicalInformation.content}
					onSubmit={(values, isFinal) => this.handleFormSubmit(values, requiredFields, validationFunc)}
					isReadonly={isReadOnly}
					allowNotes={false} allowFinal={false}
					saveDraftButtonText={t('Common_Save')} actionsAlignRight={false}
				/>}
			</div>
		);
	}

}

const mapStateToProps = (state, ownProps) => {
	const childId = ownProps.childId;

	const { entities: { children, medicalInformations }, lookups: { medicalInformationForm } } = state;

	const medicalInformation = medicalInformations[childId] || (medicalInformationForm && {
		id: 0,
		childId,
		form: medicalInformationForm,
		status: {
			id: 2,
			name: 'Draft'
		},
		content: {}
	});

	return {
		medicalInformation,
		child: children[childId],
		currentFormValues: getFormValues('customForm')(state),
		isReadOnly: false
	};
};

export default connect(mapStateToProps, {
	fetchChildMedicalInformation,
	updateChildMedicalInformation,
	changeFormValue: (field, value) => change('customForm', field, value)
})(withTranslation()(MedicalInformation));